import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;


const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    'Authorization': authToken ? `Bearer ${authToken}` : ''
  };
};



const UserController = {
  /**
   * Fetch users with pagination
   * @param {number} pageNumber - Page number to fetch
   * @param {number} pageSize - Number of items per page
   * @param {string} searchTerm - Optional search term
   * @returns {Promise<Object>} - The paginated users data
   */
  fetchUsers: async (pageNumber = 1, pageSize = 10, searchTerm = '', type = null) => {
    try {
      let url = `${API_URL}/Utilisateur/Pagination?Size=${pageSize}&PageNumber=${pageNumber}`;
      
      if (searchTerm) {
        url += `&Search=${encodeURIComponent(searchTerm)}`;
      }
      if (type) {
        url += `&Type=${encodeURIComponent(type)}`;
      }
      
      // Add auth headers to request
      const response = await axios.get(url, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  /**
   * Create a new user
   * @param {Object} userData - The user data to create
   * @returns {Promise<Object>} - The created user
   */
  createUser: async (userData) => {
    try {
      // Add auth headers to request
      const response = await axios.post(`${API_URL}/Utilisateur/Ajouter`, userData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  /**
   * Update an existing user
   * @param {Object} userData - Contains id and updated data
   * @returns {Promise<Object>} - The updated user data
   */
  updateUser: async (userData) => {
    try {
      // Add auth headers to request
      const response = await axios.put(`${API_URL}/Utilisateur/Modifier`, userData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating user #${userData.id}:`, error);
      throw error;
    }
  },

  /**
   * Delete a user by ID
   * @param {number} id - The ID of the user to delete
   * @returns {Promise<Object>} - Response from the API
   */
  deleteUser: async (id) => {
    try {
      // Add auth headers to request
      const response = await axios.delete(`${API_URL}/Utilisateur/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting user #${id}:`, error);
      throw error;
    }
  },

  /**
   * Get a user by ID
   * @param {number} id - The ID of the user to fetch
   * @returns {Promise<Object>} - The user data
   */
  getUserById: async (id) => {
    try {
      // Add auth headers to request
      const response = await axios.get(`${API_URL}/Utilisateur/ById/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching user #${id}:`, error);
      throw error;
    }
  }
};


/**
 * Fetch user profile by ID
 * @param {number} userId - The user ID
 * @returns {Promise<Object>} - User profile data
 */
export const fetchUsersProfile = async (userId) => {
  try {
    // Get the token from localStorage
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(`${API_URL}/utilisateur/byid/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch user profile:', error);
    throw error;
  }
};

/**
 * Update user profile
 * @param {Object} userData - Updated user data
 * @returns {Promise<Object>} - Updated user profile
 */
export const updateUserProfile = async (userData) => {
  try {
    // Get the token from localStorage
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(`${API_URL}/utilisateur/save`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Failed to update user profile:', error);
    throw error;
  }
};


export default UserController;




